webpackJsonp([114276838955818,60335399758886],{

/***/ 193:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"New Covenant Baptist Church","address":{"name":"","streetAddress":"14054 Wallingford Ave N","unit":"","city":"Seattle","state":"WA","zipCode":98133},"phone":"(206) 240-9648","email":"stephenjungncbc@gmail.com","instagram":"ncbcseattle"}},"allMarkdownRemark":{"edges":[{"node":{"id":"/opt/build/repo/src/pages/about/who-we-are.md absPath of file >>> MarkdownRemark","html":"<p>In 1997 a small team, led by Pastor Stephen and Ellen Jung, moved to Seattle with the vision to share the Gospel with college students and working professionals in the Puget Sound area. What started out as a small group of founding members has become an enlarged family of new brothers and sisters in Christ, who together strive to live out Jesus' Great Commandment - to love God and love one another - as well as His Great Commission - to make disciples of all nations.</p>\n<p>New Covenant Baptist Church originally started as a branch church of Berkland Baptist Church. Berkland was founded by Pastor Paul and Rebekah Kim on the border of Berkeley and Oakland, CA (hence the name \"Berkland\") in 1981. Over the years God has blessed BBC by enlarging it with branch churches throughout the United States and abroad. After 25 years of ministry, God has led us to new challenges as each branch church now serves independently, utilizing their unique gifts and talents for the Gospel.</p>\n<p>On January 28, 2007, after celebrating its 10th anniversary, our church in Seattle took on the new name, New Covenant Baptist Church, with a renewed commitment to loving God and loving one another. Regardless of where you are in life's journey, we pray that you may find a spiritual home here at New Covenant.</p>","fields":{"slug":"/about/who-we-are/"},"frontmatter":{"templateKey":"about","title":"Who We Are","navLinkText":"Who We Are","index":1}}},{"node":{"id":"/opt/build/repo/src/pages/ministries/young-adult.md absPath of file >>> MarkdownRemark","html":"<p>Ever wondered if there was more to life than the mundane 9 to 5 (or perhaps 7 to 7) workday? The Young Adult department at New Covenant is a community of twenty and thirty-something working professionals and graduate students who believe that true meaning is found in the context of a personal relationship with God through Jesus Christ. Through our small group meetings and fellowship activities, we strive to mature with one another in Christ as we learn and share life together. So, whether you are a seeker to the Christian faith trying to make sense of your busy life, or someone who has \"grown up at church\", we invite you to come and join us on this journey!</p>","fields":{"slug":"/ministries/young-adult/"},"frontmatter":{"templateKey":"ministries","title":"Young Adult","navLinkText":"Young Adult","index":1}}},{"node":{"id":"/opt/build/repo/src/pages/about/our-core-values.md absPath of file >>> MarkdownRemark","html":"<h3>The Word of God</h3>\n<p>\"Martha, Martha,\" the Lord answered, you are worried and upset about many things, but only one thing is needed. Mary has chosen what is better, and it will not be taken away from her. - Luke 10:41-42</p>\n<p>What is the most important thing in our church? NCBC is committed first and foremost to studying and obeying the Word of God. In a world that operates according to programs and agendas, we are tempted, like the busy-body Martha, to forget the most important thing. At NCBC, we are reminded that we need to be like Mary, who sat and listened with reverence and delight at Jesus' feet, before we actively serve like Martha.</p>\n<p>NCBC is committed to the study and teaching of God's word through quiet time, Bible studies, Sunday School, Sunday messages, seminars, retreats and discipleship training for personal growth and for the purposes of training and evangelism.</p>\n<h3>Preciousness of One Soul</h3>\n<p>\"Suppose one of you has a hundred sheep and loses one of them. Does he not leave the ninety-nine in the open country and go after the lost sheep until he finds it? And when he finds it, he joyfully puts it on his shoulders...and says, 'Rejoice with me; I have found my lost sheep.'\" - Luke 15:3-7</p>\n<p>Jesus taught us how precious one soul is through His parable of the shepherd who, after losing one of his 100 sheep, left the 99 to seek and to find that one lost sheep. Though some may scoff at this as being impractical and ludicrous by the world's standard, this illustrates God's tenacious and \"wasteful\" love. At NCBC, as we have experienced the same personal love from God, we strive to consider one another as valuable and precious as God does.</p>\n<h3>Lordship</h3>\n<p>Then he said to them all: \"If anyone would come after me, he must deny himself and take up his cross daily and follow me.\" - Luke 9:23</p>\n<p>In Mark 14:1-11 we see the woman who breaks her alabaster jar to anoint Jesus, symbolizing her surrender of all her hopes in people, possessions, and her life purpose (which was her hope of security and love in marriage). Her act of devotion represents how she gave up all that was dear to her and acknowledged Jesus as her Lord. At NCBC, we look to this woman as the one who understood the life of a disciple of Christ, and we strive to live a life completely surrendered to God and free of all other sources of significance.</p>\n<h3>Team Ministry and Covenant Relationships</h3>\n<p>Jonathan went to David at Horesh and helped him find strength in God...The two of them made a covenant before the LORD. - 1 Samuel 23:16-18</p>\n<p>The Bible abounds with beautiful examples of love/trust relationships. We believe that God desires that His church not only devote itself to loving Him intimately, but also to loving one another and working together toward the salvation of souls. Examples like Paul and Timothy, David and Jonathan, Naomi and Ruth serve as our models of covenant relationships. It is precisely within covenant relationships that we cultivate godly love, obedience, trust and sacrifice. At NCBC, we want to allow God to use our covenant relationships as channels for His will.</p>\n<h3>Family of God</h3>\n<p>From him the whole body, joined and held together by every supporting ligament, grows and builds itself up in love, as each part does its work. - Ephesians 4:16</p>\n<p>In a world where relationships are disconnected and families fragmented, the family of God provides a place of true connection. As we cultivate relationships at NCBC, the church becomes a web of love, and we participate in establishing God's history and roots. At NCBC, we build up God's family just as the first church described in Acts did - through fellowship. Whether it is through food, games, trials, victories, or other memory-making moments, we join together as one body with Christ as the head.</p>\n<h3>The World is our Mission Field</h3>\n<p>Beginning with one person, and going to the whole world, the NCBC family obeys God's commission to share His Good News to \"the ends of the earth.\" As we expand God's tent, we are committed to strengthening each stake, holding nothing back, as we send out and support our long-term and short-term missionaries all over the world.</p>\n<h3>Prayer and Intercession</h3>\n<p>Some men came, bringing to him a paralytic, carried by four of them. Since they could not get him to Jesus because of the crowd, they made an opening in the roof above Jesus and, after digging through it, lowered the mat the paralyzed man was lying on. - Mark 2:3-4</p>\n<p>God wants us to pray to Him. Like these four friends, we trust that when we come to God in prayer and intercession with persistence and faith, He will answer. If the Word of God is the most important principle of the church, then prayer is the second most important, and the other five principles are held by them.</p>","fields":{"slug":"/about/our-core-values/"},"frontmatter":{"templateKey":"about","title":"Our Core Values","navLinkText":"Our Core Values","index":2}}},{"node":{"id":"/opt/build/repo/src/pages/ministries/college.md absPath of file >>> MarkdownRemark","html":"<p>Koinonia Fellowship is a Christian campus group at the University of Washington. Here at Koinonia Fellowship, you will find our members coming from a variety of backgrounds and ethnicities. So what is koinonia? Koinonia is Greek for \"Christian fellowship,\" and sure enough we do a lot of that, through playing sports together, eating together, and of course, studying the Bible together.</p>\n<p>Koinonia Fellowship is not a club just for Christians. In fact, Koinonia Fellowship is full of people who simply want to find out about Christianity or to discuss profound life issues. You will find an atmosphere that welcomes questions and open discussion. We invite you to come join us for our weekly Friday Night Bible Studies (FNBS), which feature the Word of God, music, drama, multimedia presentations, games, and great food! Afterwards, you will meet not only other new students, but also many friendly upperclassman eager to offer you their own personal \"survival tips\" for safely navigating through life at the UW.</p>","fields":{"slug":"/ministries/college/"},"frontmatter":{"templateKey":"ministries","title":"College","navLinkText":"College","index":2}}},{"node":{"id":"/opt/build/repo/src/pages/about/our-pastor.md absPath of file >>> MarkdownRemark","html":"<p>Pastor Stephen Jung is the senior pastor at New Covenant Baptist Church (NCBC) in Seattle. He earned a Bachelor of Science degree in Civil Engineering from the University of California Berkeley and a Master of Divinity at Golden Gate Baptist Theological Seminary.</p>\n<p>Pastor Stephen and his wife Ellen started their spiritual journey together on the UC Berkeley campus. Their passion to follow God’s call led them to start NCBC in 1997 with the vision to share the Gospel to college students and young working professionals. Together they lead the various departments and ministries at NCBC from teaching Bible studies to coordinating church-wide fellowship activities.</p>\n<p>When he’s not preaching at the pulpit, and she’s not overseeing the diverse aspects of ministries at NCBC, you can find Pastor Stephen and Ellen leading a caravan of college students on a roadtrip, trekking up and on nearby mountains, offering counsel at their office hours, opening their home to you to simply hang out, or racing across fields/courts – whether basketball, soccer, tennis or volleyball. In whatever activity you catch both of them doing, you will find their childlike joy and spontaneity in Christ evident and extremely contagious.</p>","fields":{"slug":"/about/our-pastor/"},"frontmatter":{"templateKey":"about","title":"Our Pastor","navLinkText":"Our Pastor","index":3}}},{"node":{"id":"/opt/build/repo/src/pages/ministries/children.md absPath of file >>> MarkdownRemark","html":"<p>The vision of the children's ministry has always been to raise children following the ABCs: the Attitude, Behavior and Character of Christ. In Matthew 22:37-39, Jesus says the greatest commandment is \"Love the Lord your God with all your heart and with all your soul and with all your mind. And the second is like it: Love your neighbor as yourself.\" We are founded on the belief that true J.O.Y. comes from putting Jesus first, then Others, and then Yourself - hence our name! Come join us in JOY Adventure (4th-6th grade), JOYland (K-3rd grade), or JOY Corner (0-4 years old) as we lay the foundation for a lifetime of knowing, loving, and serving God!</p>","fields":{"slug":"/ministries/children/"},"frontmatter":{"templateKey":"ministries","title":"Children","navLinkText":"Children","index":3}}},{"node":{"id":"/opt/build/repo/src/pages/index.md absPath of file >>> MarkdownRemark","html":"","fields":{"slug":"/"},"frontmatter":{"templateKey":"index","title":"New Covenant Baptist Church","navLinkText":null,"index":null}}},{"node":{"id":"/opt/build/repo/src/pages/giving/index.md absPath of file >>> MarkdownRemark","html":"<p>You can give tithes and offerings online via <a href=\"https://www.zellepay.com/\">Zelle</a> or by mailing a check. We appreciate your generosity and looking forward to see what God will do through it!</p>\n<h3>Giving Online</h3>\n<p>Giving online is available through <a href=\"https://www.zellepay.com/get-started\">Zelle</a>. Once setup, use the following information to send your tithes and offerings:</p>\n<p><strong>Recipient Name</strong>: Berkland Baptist Church (NCBC's former name)<br>\n<strong>Email</strong>: ncbcoffering@gmail.com</p>\n<h3>Mailing A Check</h3>\n<p>If you prefer mailing a check, you can mail it to:</p>\n<address>\n  New Covenant Baptist Church (Room 202)<br />\n  1604 NE 50th St<br />\n  Seattle, WA 98105\n</address>","fields":{"slug":"/giving/"},"frontmatter":{"templateKey":"giving","title":"Expand God's Kingdom Through Your Generosity","navLinkText":null,"index":null}}},{"node":{"id":"/opt/build/repo/src/pages/devotional/index.md absPath of file >>> MarkdownRemark","html":"","fields":{"slug":"/devotional/"},"frontmatter":{"templateKey":"devotional","title":"Daily Devotion","navLinkText":null,"index":null}}},{"node":{"id":"/opt/build/repo/src/pages/events/index.md absPath of file >>> MarkdownRemark","html":"<h2>July Wednesday Bible Study &#x26; Fellowship</h2>\n<p>The Book of Revelation. Many people might consider it to be the most difficult book in the New Testament. It is full of strange and sometimes violent imagery. It is something right out of an imaginative fantasy or ‘apocalyptic’ movie. So, Christians feel uneasy and wonder if the book has any relevant purpose in today’s Christian life.</p>\n<p>Early Christians wondered, as the church grew and as they suffered persecution. Why was God allowing the tribulation? What were God’s ultimate plan for little churches in the threat of the empire’s power? Forced to worship Caesar or be persecuted and even death, what were they supposed to do? Where and how will it all end? After all, were Christians to give in and bow to the lords of the earth, including the Caesar?</p>\n<p>And the answer to all these questions came to a pastor, called John of Patmos in visions. Revelation (=apocalypse) is written to say no to these questions and much more! </p>\n<blockquote>\n<p>1:1(ESV) The revelation of Jesus Christ, which God gave him to show to his servants the things that must soon take place. He made it known by sending his angel to his servant John.</p>\n</blockquote>\n<p>So, let us not be deterred by the difficulties of the book. It is one of the most wonderful and inspiring book in the New Testament that will lead us to more meaningful worship of our God the Father and Creator. Even though the time is not favorable to worship. But remember the devil hates us worshipping God. The study of Revelation will strengthen our resolve and faith in the Lord Jesus and lead us to deeper love and worship of our Sovereign, Creator God.</p>\n<h3>When</h3>\n<p>Wednesdays in July, 7:30–9:00 PM @ Church</p>\n<img src=\"/assets/unknown-artist-agnus-dei-lamb-of-god-basilica-dei-santi-cosma-e-damiano-roma-italy-7th-century.jpg\" alt=\"agnus-dei-lamb-of-god-basilica-dei-santi-cosma-e-damiano-roma-italy-7th-century\" width=\"460px\" style=\"max-width: 100%; padding: 10px; background-color: #fbfbfb; border: 1px solid #ececec; display: block; margin-top: 32px; transform: rotate(-2deg); margin-left: -48px;\">","fields":{"slug":"/events/"},"frontmatter":{"templateKey":"events","title":"July Bible Study & Fellowship","navLinkText":null,"index":null}}},{"node":{"id":"/opt/build/repo/src/pages/location/index.md absPath of file >>> MarkdownRemark","html":"<p>Our weekly Sunday worship service is held at the following location in the sanctuary at 12:00 pm.</p>\n<h3>Service Time</h3>\n<p>Sundays at 12:00 pm</p>\n<h3>Location</h3>\n<address>\n  10510 Stone Ave N<br />\n  Seattle, WA 98133\n</address>\n<p><a href=\"tel:+1(206) 240-9648\">(206) 240-9648</a></p>","fields":{"slug":"/location/"},"frontmatter":{"templateKey":"location","title":"Come and Visit Us","navLinkText":null,"index":null}}}]}},"layoutContext":{}}

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(279);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(193);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _instagram = __webpack_require__(398);
	
	var _instagram2 = _interopRequireDefault(_instagram);
	
	var _envelope = __webpack_require__(396);
	
	var _envelope2 = _interopRequireDefault(_envelope);
	
	var _boxLogo = __webpack_require__(395);
	
	var _boxLogo2 = _interopRequireDefault(_boxLogo);
	
	var _FooterModule = __webpack_require__(329);
	
	var _FooterModule2 = _interopRequireDefault(_FooterModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(_ref) {
	  var address = _ref.address,
	      email = _ref.email,
	      phone = _ref.phone,
	      instagram = _ref.instagram,
	      pages = _ref.pages;
	
	  var currentYear = new Date().getFullYear();
	  var ncbc = 'New Covenant Baptist Church';
	  var name = address.name,
	      streetAddress = address.streetAddress,
	      unit = address.unit,
	      city = address.city,
	      state = address.state,
	      zipCode = address.zipCode;
	
	
	  var aboutPages = [];
	  var ministriesPages = [];
	
	  pages.forEach(function (_ref2) {
	    var page = _ref2.node;
	
	    if (page.frontmatter.templateKey === 'about') {
	      aboutPages.push(page);
	    }
	
	    if (page.frontmatter.templateKey === 'ministries') {
	      ministriesPages.push(page);
	    }
	  });
	
	  return _react2.default.createElement(
	    'footer',
	    { className: _FooterModule2.default.component },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: _FooterModule2.default.footerContent },
	        _react2.default.createElement(
	          'div',
	          { className: _FooterModule2.default.leftCol },
	          _react2.default.createElement(
	            'div',
	            { className: _FooterModule2.default.brandContainer },
	            _react2.default.createElement(_boxLogo2.default, { className: _FooterModule2.default.logo }),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { className: _FooterModule2.default.brand, to: '/' },
	              'New Covenant Baptist Church'
	            )
	          ),
	          _react2.default.createElement(
	            'address',
	            null,
	            name && _react2.default.createElement(
	              'span',
	              null,
	              name,
	              ' ',
	              unit && '(' + unit + ')'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              streetAddress,
	              ', ',
	              city,
	              ', ',
	              state,
	              ' ',
	              zipCode
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: 'tel:+1' + phone },
	              phone
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _FooterModule2.default.sbc },
	            'NCBC adheres to the Statement of Faith adopted by the',
	            ' ',
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'http://www.sbc.net/',
	                target: '_blank',
	                rel: 'noopener noreferrer'
	              },
	              'Southern Baptist Convention'
	            ),
	            '.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _FooterModule2.default.rightCol },
	          _react2.default.createElement(
	            'nav',
	            { className: _FooterModule2.default.footerNav },
	            _react2.default.createElement(
	              'div',
	              { className: _FooterModule2.default.footerNavCol },
	              _react2.default.createElement(
	                'h2',
	                { className: _FooterModule2.default.footerNavTitle },
	                'About'
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                aboutPages.map(function (page) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: page.id },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: page.fields.slug },
	                      page.frontmatter.navLinkText
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _FooterModule2.default.footerNavCol },
	              _react2.default.createElement(
	                'h2',
	                { className: _FooterModule2.default.footerNavTitle },
	                'Ministries'
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                ministriesPages.map(function (page) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: page.id },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: page.fields.slug },
	                      page.frontmatter.navLinkText
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _FooterModule2.default.footerNavCol },
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/devotional', className: _FooterModule2.default.footerNavTitle },
	                    'Devotional'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/location', className: _FooterModule2.default.footerNavTitle },
	                    'Location'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/giving', className: _FooterModule2.default.footerNavTitle },
	                    'Giving'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _FooterModule2.default.socialLinks },
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.instagram.com/' + instagram + '/',
	                target: '_blank',
	                rel: 'noopener noreferrer'
	              },
	              _react2.default.createElement(_instagram2.default, { className: _FooterModule2.default.socialLinkIcon })
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:' + email },
	              _react2.default.createElement(_envelope2.default, { className: _FooterModule2.default.socialLinkIcon })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _FooterModule2.default.copyright },
	        _react2.default.createElement(
	          'p',
	          null,
	          '\xA9 ',
	          currentYear,
	          ' ',
	          ncbc,
	          '. All rights reserved.'
	        )
	      )
	    )
	  );
	};
	
	Footer.propTypes = {
	  address: _propTypes2.default.object.isRequired,
	  email: _propTypes2.default.string.isRequired,
	  phone: _propTypes2.default.string.isRequired,
	  instagram: _propTypes2.default.string.isRequired,
	  pages: _propTypes2.default.array
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 329:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"component":"src-components-Footer----Footer-module---component---1mIad","brandContainer":"src-components-Footer----Footer-module---brandContainer---2ghYy","brand":"src-components-Footer----Footer-module---brand---1lW5E","logo":"src-components-Footer----Footer-module---logo---1eKbS","footerContent":"src-components-Footer----Footer-module---footerContent---14VEB","leftCol":"src-components-Footer----Footer-module---leftCol---15c8O","rightCol":"src-components-Footer----Footer-module---rightCol---3QdN3","footerNav":"src-components-Footer----Footer-module---footerNav---1-xSK","footerNavCol":"src-components-Footer----Footer-module---footerNavCol---1qYYM","footerNavTitle":"src-components-Footer----Footer-module---footerNavTitle---3HlFi","socialLinks":"src-components-Footer----Footer-module---socialLinks---1uERr","socialLinkIcon":"src-components-Footer----Footer-module---socialLinkIcon---2sGt_","sbc":"src-components-Footer----Footer-module---sbc---17DsI","copyright":"src-components-Footer----Footer-module---copyright---2-iNN"};

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Nav = __webpack_require__(120);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _logo = __webpack_require__(250);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _HeaderModule = __webpack_require__(181);
	
	var _HeaderModule2 = _interopRequireDefault(_HeaderModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    'header',
	    { className: (_HeaderModule2.default.component + ' ' + className).trim() },
	    _react2.default.createElement(
	      'div',
	      { className: _HeaderModule2.default.navContainer },
	      _react2.default.createElement(
	        'div',
	        { className: _HeaderModule2.default.brandContainer },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _HeaderModule2.default.brand, to: '/' },
	          _react2.default.createElement(_logo2.default, { className: _HeaderModule2.default.logo }),
	          _react2.default.createElement(
	            'span',
	            { className: _HeaderModule2.default.brandName },
	            'New Covenant Baptist Church'
	          )
	        )
	      ),
	      _react2.default.createElement(_Nav2.default, null)
	    )
	  );
	};
	
	Header.defaultProps = {
	  className: ''
	};
	
	Header.propTypes = {
	  className: _propTypes2.default.string
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 181:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"component":"src-components-Header----Header-module---component---2wP_t","navContainer":"src-components-Header----Header-module---navContainer---17soM","brandContainer":"src-components-Header----Header-module---brandContainer---XbKCu","brand":"src-components-Header----Header-module---brand---34r6-","brandName":"src-components-Header----Header-module---brandName---39hpj","logo":"src-components-Header----Header-module---logo---2Zf4H"};

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _NavModule = __webpack_require__(182);
	
	var _NavModule2 = _interopRequireDefault(_NavModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nav = function (_React$Component) {
	  _inherits(Nav, _React$Component);
	
	  function Nav() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Nav);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      showLinks: false
	    }, _this.handleMouseDown = function (event) {
	      if (_this.navRef && !_this.navRef.contains(event.target) && _this.hamburgerMenuRef && !_this.hamburgerMenuRef.contains(event.target)) {
	        _this.setState(function (_ref) {
	          var showLinks = _ref.showLinks;
	          return showLinks ? { showLinks: false } : null;
	        });
	      }
	    }, _this.handleHamburgerMenuClick = function (event) {
	      _this.setState(function (_ref2) {
	        var showLinks = _ref2.showLinks;
	        return {
	          showLinks: !showLinks
	        };
	      });
	    }, _this.handleLinkClick = function () {
	      return _this.setState({ showLinks: false });
	    }, _this.setNavRef = function (ref) {
	      return _this.navRef = ref;
	    }, _this.setHamburgerMenuRef = function (ref) {
	      return _this.hamburgerMenuRef = ref;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Nav.prototype.componentDidMount = function componentDidMount() {
	    document.addEventListener('mousedown', this.handleMouseDown);
	  };
	
	  Nav.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('mousedown', this.handleMouseDown);
	  };
	
	  Nav.prototype.render = function render() {
	    var showLinks = this.state.showLinks;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (_NavModule2.default.component + ' ' + (showLinks ? _NavModule2.default.navbarToggleShow : '')).trim()
	      },
	      _react2.default.createElement(
	        'button',
	        {
	          ref: this.setHamburgerMenuRef,
	          className: _NavModule2.default.navbarToggle,
	          'aria-label': 'Menu',
	          onClick: this.handleHamburgerMenuClick
	        },
	        _react2.default.createElement('span', { className: _NavModule2.default.hamburgerLine }),
	        _react2.default.createElement('span', { className: _NavModule2.default.hamburgerLine }),
	        _react2.default.createElement('span', { className: _NavModule2.default.hamburgerLine })
	      ),
	      _react2.default.createElement(
	        'nav',
	        { ref: this.setNavRef, className: _NavModule2.default.navbar },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/about/', onClick: this.handleLinkClick },
	              'About'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/ministries/', onClick: this.handleLinkClick },
	              'Ministries'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/events/', onClick: this.handleLinkClick },
	              'Events'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/devotional/', onClick: this.handleLinkClick },
	              'Devotional'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/location/', onClick: this.handleLinkClick },
	              'Location'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/giving/', onClick: this.handleLinkClick },
	              'Giving'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Nav;
	}(_react2.default.Component);
	
	exports.default = Nav;
	module.exports = exports['default'];

/***/ }),

/***/ 182:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"component":"src-components-Nav----Nav-module---component---nrEnJ","navbarToggle":"src-components-Nav----Nav-module---navbarToggle---aqzei","hamburgerLine":"src-components-Nav----Nav-module---hamburgerLine---2P-RU","navbar":"src-components-Nav----Nav-module---navbar---faogX","navbarToggleShow":"src-components-Nav----Nav-module---navbarToggleShow---2uWvW"};

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAAHdbkFIAAAACXBIWXMAAAsSAAALEgHS3X78AAAC10lEQVR4Ae2b0W3bMBCGT0Df60xQdwN3gjgTxAX0XmeCxhMwnKDpBPEABJpMEGeCOhPYG1QbpKB4lGmKlEVZSt3k/wADkRxS5PF4Jv+j6ATIqibk4qX6W8nqflZrYy7GRLQ5hdYnkotprIDpZi7+ENGovOPYgCJ2CBoM1KxkzOreG9XuMR/IjoOSZ3umzcU1Ef1w/lcGhuQ3rA96piFstEdHTTMXxntlcvErVocbmydEFPLtJSl5Fa8gF7MyoCm59J76snftxy/TSnE4qPkV7TgjJYuD5QEA4DChaLji1drEKf2ZlNy2tmcu5rXgGKHdCi8eEH0kKXnTuqHV2mj3IF1YOHe2/CmqNWyYq7Y99slSzOU1NmXPoId1zB/LgpS87XeRbX56Z5FvtRW/JPkSAAAAAMBrEJIl7Yp4/Ro7cHdZ/ujcdyWTRpGihu5AQsOtOhgulIs7IprzVfOSWy9uie543bdOa0ATdekyTgclOVxgv+dtuCAlV6kP1+w2Jsb5Nt4GxFbaJKPdlw7bhVyMrA9suJJF47rdbEYevQ2Gi62j2Rp2WJXMslSvdSppO0xhK7K/HL8zSveXW1JyYS/625oZzTKqiibHEwAAAAAAAAAAAIA3TVyWMacovnEGPKSEbVmW+/k/Z8H9c21a/v1IRA9Rec/oT5cBMawojWGEr36EdaOXXvNAXAxh6D6UwRnr4qFTJdpDnlgz3c84GJ3VepaWLT9xZsI9r7Pmjg+WqehmANPpc274pEWJFFYsMHdTvBNpk6DQrv59gI5aZK/TJpFQkuyGO2xdesuj8hx05Xr5KXvGZQejFfysh3L6DGUUE+B1H8uDW2NOQRUc/O4HeuiUT6Udc2Z6xYPwXA5MUx7G9GsSmapVouDfvZ3BJ6kTUyvHoD35qx9bTuf1FGOQuTf9jmXJ2d3oz+fpv5+ziynngWOt5BzwfCqnSMdkLQAAAAAAeFcQ0V8+7emSPG4pGAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function BoxLogo (props) {
	    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.box-logo{fill:#FFFFFF;}\n"),React.createElement("g",{"key":1},[React.createElement("path",{"className":"box-logo","d":"M0,10.4v4.8c2-0.8,4.2-1.5,6.3-1.8C6.3,13.4,3.9,10.7,0,10.4z","key":0}),React.createElement("path",{"className":"box-logo","d":"M4.9,10.1c3.4,1.8,5,2.9,8.3,2.9c0,0,6.5,0.1,10.4-2.7c0,0-2.8,3.8-8.2,5.1c1.4,0.7,6.6,2.6,11.6,3.3\n\t\tc1.7,0.2,3.4,0.2,4.9,0V0H0v9.3C1.5,9,3.2,9.2,4.9,10.1z","key":1}),React.createElement("path",{"className":"box-logo","d":"M25.9,22.8c-7.1-0.2-11.9-5-18.5-6.4c-2.3-0.5-5-0.2-7.4,0.3V32h32V21.5C30.2,22.3,28.2,22.9,25.9,22.8z","key":2})])]);
	}
	
	BoxLogo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 32 32","style":{"enableBackground":"new 0 0 32 32"},"xmlSpace":"preserve"};
	
	module.exports = BoxLogo;
	
	BoxLogo.default = BoxLogo;


/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Envelope (props) {
	    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.envelope{fill:#FFFFFF;}\n"),React.createElement("title",{"key":1}),React.createElement("g",{"id":"icomoon-ignore","key":2}),React.createElement("path",{"className":"envelope","d":"M29.6,25.4V11.7c-0.4,0.4-0.8,0.8-1.2,1.2c-2.6,2-5.1,4-7.6,6c-1.3,1.1-3,2.5-4.9,2.5h0c-1.9,0-3.5-1.4-4.9-2.5\n\tc-2.5-2.1-5.1-4.1-7.6-6c-0.4-0.4-0.9-0.8-1.2-1.2v13.7c0,0.3,0.3,0.6,0.6,0.6h26.3C29.4,25.9,29.6,25.7,29.6,25.4z M29.6,6.6\n\tc0-0.4,0.1-1.2-0.6-1.2H2.8c-0.3,0-0.6,0.3-0.6,0.6c0,2,1,3.8,2.6,5.1c2.4,1.9,4.8,3.8,7.2,5.7c0.9,0.8,2.7,2.4,3.9,2.4h0\n\tc1.2,0,3-1.6,3.9-2.4c2.4-1.9,4.8-3.8,7.2-5.7C28.2,10.1,29.6,8.1,29.6,6.6z M31.9,5.9v19.4c0,1.6-1.3,2.9-2.9,2.9H2.8\n\tc-1.6,0-2.9-1.3-2.9-2.9V5.9c0-1.6,1.3-2.9,2.9-2.9h26.3C30.6,3.1,31.9,4.4,31.9,5.9z","key":3})]);
	}
	
	Envelope.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 31.9 31.3","style":{"enableBackground":"new 0 0 31.9 31.3"},"xmlSpace":"preserve"};
	
	module.exports = Envelope;
	
	Envelope.default = Envelope;


/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Instagram (props) {
	    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.instagram{fill:#FFFFFF;}\n"),React.createElement("title",{"key":1},"Asset 1"),React.createElement("g",{"id":"Layer_2_1_","key":2},React.createElement("g",{"id":"Layer_1-2"},[React.createElement("path",{"className":"instagram","d":"M16.1,0C11.7,0,11,0,9.5,0c-1.4,0-2.7,0.3-4,0.8C3.4,1.7,1.7,3.4,0.8,5.5C0.3,6.8,0,8.1,0,9.5\n\t\t\tc0,1.5,0,2.3,0,6.6s0,4.9,0,6.6c0,1.3,0.2,2.7,0.7,3.9c0.4,1.1,1.1,2.1,1.9,2.9c0.8,0.8,1.8,1.5,2.9,1.9c1.3,0.5,2.6,0.7,3.9,0.7\n\t\t\tc1.7,0,2.3,0,6.6,0s4.9,0,6.6,0c1.3,0,2.7-0.2,3.9-0.7c2.2-0.9,3.9-2.6,4.7-4.7c0.5-1.2,0.7-2.6,0.7-3.9c0-1.7,0-2.3,0-6.6\n\t\t\ts0-4.9,0-6.6c0-1.4-0.2-2.7-0.7-4c-0.4-1.1-1.1-2-1.9-2.8c-0.8-0.8-1.8-1.5-2.9-1.9C25.4,0.3,24,0,22.7,0C21,0,20.4,0,16.1,0z\n\t\t\t M16.1,2.9h6.5c1,0,2,0.2,3,0.6C27,4,28.1,5.1,28.6,6.6c0.3,1,0.5,2,0.6,3c0,1.7,0,2.2,0,6.5s0,4.8,0,6.5c0,1-0.2,2-0.6,3\n\t\t\tc-0.6,1.4-1.7,2.5-3.1,3.1c-1,0.3-2,0.5-3,0.6h-13c-1,0-2-0.2-3-0.6c-1.4-0.6-2.5-1.7-3.1-3.1c-0.3-1-0.5-2-0.6-3\n\t\t\tc0-1.7,0-2.2,0-6.5s0-4.8,0-6.5c0-1,0.2-2,0.6-3c0.6-1.4,1.7-2.5,3.1-3c1-0.3,2-0.5,3-0.6L16.1,2.9","key":0}),React.createElement("path",{"className":"instagram","d":"M16.1,21.4c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5s5.5,2.5,5.5,5.5S19.1,21.4,16.1,21.4z M16.1,7.8\n\t\t\tc-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3s8.3-3.7,8.3-8.3S20.6,7.8,16.1,7.8z","key":1}),React.createElement("path",{"className":"instagram","d":"M26.6,7.5c0,1.1-0.9,1.9-1.9,1.9c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9S26.6,6.4,26.6,7.5\n\t\t\tC26.6,7.5,26.6,7.5,26.6,7.5z","key":2})]))]);
	}
	
	Instagram.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 32 32.1","style":{"enableBackground":"new 0 0 32 32.1"},"xmlSpace":"preserve"};
	
	module.exports = Instagram;
	
	Instagram.default = Instagram;


/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Logo (props) {
	    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.logo{fill:#00547F;}\n"),React.createElement("path",{"className":"logo","d":"M70.4,19.1c4.5,2.3,20.7,8,36.4,10.3c14.6,2.1,26.4-2.4,37.2-7.2c0,0-17.5,20.8-40.9,20.2\n\tc-22.2-0.5-37.1-15.8-57.9-20c-18-3.7-45.2,7.7-45.2,7.7s22-14.9,41.7-17.1c0,0-14.4-16.2-34.9-6.3c0,0,14.9-12.4,30.5-4.3\n\tc10.5,5.5,15.6,9,26,9c0,0,20.4,0.4,32.7-8.3C96.1,3.2,87.4,15.1,70.4,19.1z","key":1})]);
	}
	
	Logo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 144 42","style":{"enableBackground":"new 0 0 144 42"},"xmlSpace":"preserve"};
	
	module.exports = Logo;
	
	Logo.default = Logo;


/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(119);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(278);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _favicon = __webpack_require__(400);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	__webpack_require__(387);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    _classCallCheck(this, Layout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Layout.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('mousedown', this.handleMouseDown);
	    window.addEventListener('keydown', this.handleKeyDown);
	  };
	
	  Layout.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('mousedown', this.handleMouseDown);
	    window.removeEventListener('keydown', this.handleKeyDown);
	  };
	
	  Layout.prototype.handleMouseDown = function handleMouseDown() {
	    document.body.classList.add('usingMouse');
	  };
	
	  Layout.prototype.handleKeyDown = function handleKeyDown() {
	    document.body.classList.remove('usingMouse');
	  };
	
	  Layout.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        location = _props.location,
	        children = _props.children;
	    var pages = data.allMarkdownRemark.edges;
	    var _data$site$siteMetada = data.site.siteMetadata,
	        title = _data$site$siteMetada.title,
	        address = _data$site$siteMetada.address,
	        phone = _data$site$siteMetada.phone,
	        email = _data$site$siteMetada.email,
	        instagram = _data$site$siteMetada.instagram;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: title,
	        meta: [{
	          name: 'description',
	          content: 'Welcome to New Covenant Baptist Church!'
	        }, {
	          name: 'keywords',
	          content: 'baptist, church, seattle, uw, university district, college, student, young adult, ministry'
	        }],
	        link: [{ rel: 'shortcut icon', type: 'image/png', href: '' + _favicon2.default }]
	      }),
	      location.pathname === '/' ? children() : _react2.default.createElement(_Header2.default, null),
	      location.pathname !== '/' && children(),
	      _react2.default.createElement(_Footer2.default, {
	        address: address,
	        phone: phone,
	        email: email,
	        instagram: instagram,
	        pages: pages
	      })
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 387:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-0fd77d16c847d3b71a30.js